/** Client-side mirrors of the backend bean-validation rules (fail fast before the request). */

export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim());

// Backend: min 8 chars, upper + lower + digit + special (RegisterClientRequest).
export const isStrongPassword = (v) =>
  /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!]).{8,}$/.test(v || '');

// Backend: ^\+?[1-9]\d{1,14}$
export const isPhone = (v) => /^\+?[1-9]\d{1,14}$/.test(String(v || '').replace(/[\s()-]/g, ''));

export const isNotBlank = (v) => String(v || '').trim().length > 0;

export const minLength = (v, n) => String(v || '').trim().length >= n;

export const isPositiveNumber = (v) => v !== '' && v !== null && !Number.isNaN(Number(v)) && Number(v) > 0;

export const inRange = (v, min, max) => {
  const n = Number(v);
  return !Number.isNaN(n) && n >= min && n <= max;
};

/**
 * Runs a `{ field: [ [predicate, message], ... ] }` spec against `values`.
 * Returns `{}` when valid, otherwise `{ field: firstFailingMessage }`.
 */
export function validate(values, spec) {
  const errors = {};
  Object.entries(spec).forEach(([field, rules]) => {
    for (const [predicate, message] of rules) {
      if (!predicate(values[field], values)) {
        errors[field] = message;
        break;
      }
    }
  });
  return errors;
}
